<template>
  <div class="indexcontainer" id="myElement" ref="myindexcontainer">
    <div class="inAndOutOfWater">
      <div class="water_info" v-for="(item, index) in o" :key="index">
        <div v-if="item.name == 'Influent'" class="watertitle">Plant Influent</div>
        <div v-else class="watertitle">Effluent Volume</div>
        <div class="water_table" ref="watertable">
          <el-table :data="item.value" :ref="'tableref' + index" style="width: 100%" :height="tableheight">
            <el-table-column prop="visible" label="Indicator"> </el-table-column>
            <el-table-column prop="current" label="Value" width="100"> </el-table-column>
            <el-table-column prop="unit" label="Unit" width="80"> </el-table-column>
          </el-table>
        </div>
        <div class="water_chartbox" v-if="show">
          <el-select v-model="item.selectvalue" ref="mySelect" @blur="clickOutSide(index)" placeholder="Select"
            @change="selectChanged(index, item.selectvalue)">
            <el-option v-for="item1 in item.chartdata.data" :key="item1.title" :label="item1.title"
              :value="item1.title">
            </el-option>
          </el-select>
          <div class="water_chart">
            <iochart class="iochart" :codMain="item.name" :ChartData="item.selectchart">
            </iochart>
          </div>
        </div>
      </div>
    </div>
    <div class="allwarning">
      <div class="jingaoContainer" id="jingaoContainer">
        <span class="jingaospan">Alarm</span>
        <el-table id="tableData" :data="alertAllData" :show-header="false" :row-style="{ height: '67px' }"
          class="jinggao_table" :max-height="height" @row-click="handle">
          <el-table-column width="120" class="first" align="center">
            <template slot-scope="scope">
              <span style="color: rgba(235, 107, 106, 1);">【System Alarm】</span>
            </template>
          </el-table-column>
          <el-table-column prop="noti_detail" width="180"></el-table-column>
          <el-table-column label="type" align="center" width="90">
            <template slot-scope="scope">
              <i v-if="scope.row.status_des == '待处理'" class="dotClass" style="background-color: red"></i>
              <i v-if="scope.row.status_des == '已完成'" class="dotClass" style="background-color: rgb(23, 155, 238)"></i>
              {{ scope.row.status_des }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="indexcontainer_fack">
      <div class="container_fack"></div>
    </div>
    <div class="demo" ref="demo">
      <ul>
        <li v-for="(item, index) in transform" :key="item" :style="{ transform: item }"
          @click="gotodetail(inAerationData[index].result)" ref="demoli">
          <div class="text_box">
            <div class="module_title" style="color: rgba(204, 204, 204, 1)">
              {{ inAerationData[index].result.name }}
              <img src="../../assets/Switch (5).png" alt="" v-if="inAerationData[index].result.runbtn" />
              <img src="../../assets/Switch (2).png" alt="" v-else />
            </div>
            <div class="module_type" v-if="inAerationData[index].result.operate_status.status !== 5" :style="inAerationData[index].result.operate_status.status == 3
              ? 'color:rgba(176, 129, 60, 1);'
              : inAerationData[index].result.operate_status.status == 4
                ? 'color:#498AF4'
                : inAerationData[index].result.operate_status.status == 2
                  ? 'color:#D43030'
                  : inAerationData[index].result.operate_status.status == 5
                    ? 'color:rgba(23, 130, 212, 1)'
                    : ''
              ">
              {{ inAerationData[index].result.operate_status.des }}
            </div>
          </div>
        </li>
      </ul>
    </div>
    <ul class="text_bord">
      <li class="bord" v-for="(i, index) in listlength"
        :style="'transform:rotate(' + ((i - 1) * 360) / listlength + 'deg)'" :key="index">
        <div class="bordbox"></div>
      </li>
    </ul>
    <ul class="pie_bord" id="box">
      <li class="bord" v-for="(i, index) in listlength"
        :style="'transform:rotate(' + ((i - 1) * 360) / listlength + 'deg)'" :key="index">
        <div class="imgbox">
          <img src="../../assets/group7 (1).png" alt="" />
        </div>
      </li>
    </ul>
    <ul class="pie" id="pie" :style="hoverindex ? 'overflow: visible;' : ''" ref="mypie">
      <li class="slice" v-for="(i, index) in listlength" :key="index" :style="hoverindex == i
        ? 'transform:rotate(' +
        ((i - 1) * 360) / listlength +
        'deg) scale(1.1);clip-path: polygon(0% 100%, 0% 0%, ' +
        Math.tan(((360 / listlength) * Math.PI) / 180) * 100 +
        '% 00%);'
        : 'transform:rotate(' +
        ((i - 1) * 360) / listlength +
        'deg);clip-path:  polygon(0% 100%, 0% 0%, ' +
        Math.tan(((360 / listlength) * Math.PI) / 180) * 100 +
        '% 00%);'
        " v-on:mouseenter="logsome(i)" :class="hoverindex == i ? 'hoverstyle' : ''" v-on:mouseleave="leave(i)"
        @click="gotodetail(inAerationData[i - 1].result)">
        <div class="">
          <div :id="'containerpie' + i" :style="'transform:rotate(' + (-(i - 1) * 360) / listlength + 'deg)'"
            class="containerpie"></div>
        </div>
      </li>
    </ul>
    <ul class="myline" id="myline">
      <li class="line" v-for="(i, index) in listlength" :key="index" :style="hoverindex == i
        ? 'transform:rotate(' +
        ((i - 1) * 360) / listlength +
        'deg) scale(1.1);clip-path: polygon(0% 100%, 0% 0%, ' +
        Math.tan(((360 / listlength) * Math.PI) / 180) * 100 +
        '% 00%);'
        : 'transform:rotate(' +
        ((i - 1) * 360) / listlength +
        'deg);clip-path:  polygon(0% 100%, 0% 0%, ' +
        Math.tan(((360 / listlength) * Math.PI) / 180) * 100 +
        '% 00%);'
        " v-on:mouseenter="logsome(i)" :class="hoverindex == i ? 'hoverstyle' : ''">
        <div class="">
          <div class="line_container" :id="'line' + i"
            :style="'transform:rotate(' + (-(i - 1) * 360) / listlength + 'deg)'"></div>
        </div>
      </li>
    </ul>
    <ul class="myline2" id="myline2">
      <li class="line2" v-for="(i, index) in listlength" :key="index" :style="hoverindex == i
        ? 'transform:rotate(' +
        ((i - 1) * 360) / listlength +
        'deg) scale(1.1);clip-path:  polygon(0% 100%, 0% 0%, ' +
        Math.tan(((360 / listlength) * Math.PI) / 180) * 100 +
        '% 00%);'
        : 'transform:rotate(' +
        ((i - 1) * 360) / listlength +
        'deg);clip-path:  polygon(0% 100%, 0% 0%, ' +
        Math.tan(((360 / listlength) * Math.PI) / 180) * 100 +
        '% 00%);'
        " v-on:mouseenter="logsome(i)" :class="hoverindex == i ? 'hoverstyle' : ''">
        <div class="">
          <div class="line_container2" :id="'line2' + i"
            :style="'transform:rotate(' + (-(i - 1) * 360) / listlength + 'deg)'"></div>
        </div>
      </li>
    </ul>
    <ul class="mycategory" id="mycategory" ref="mycategory">
      <li class="category" v-for="(i, index) in listlength" :key="index" :style="hoverindex == i
        ? 'transform:rotate(' +
        ((i - 1) * 360) / listlength +
        'deg) scale(1.1);clip-path:  polygon(0% 100%, 0% 0%, ' +
        Math.tan(((360 / listlength) * Math.PI) / 180) * 100 +
        '% 00%);'
        : 'transform:rotate(' +
        ((i - 1) * 360) / listlength +
        'deg);clip-path:  polygon(0% 100%, 0% 0%, ' +
        Math.tan(((360 / listlength) * Math.PI) / 180) * 100 +
        '% 00%);'
        " v-on:mouseenter="logsome(i)" :class="hoverindex == i ? 'hoverstyle' : ''">
        <div class="">
          <div class="category_container" :id="'category' + i"
            :style="'transform:rotate(' + (-(i - 1) * 360) / listlength + 'deg)'"></div>
        </div>
      </li>
    </ul>
    <ul class="myradar" id="myradar">
      <li class="radar">
        <div class="">
          <div class="radar_container" :id="'radar'"></div>
        </div>
      </li>
    </ul>
    <div class="tip_box">
      <div class="tip_littlebox" ref="tiplittlebox">
        <div class="tip" v-for="(item, index) in tiplist" :style="item.type == 1 ? 'width: 100%;' : ''" :key="index">
          <img :src="item.url" alt="" />
          <div>
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iochart from "../../components/component/iochart.vue";
import { mapState } from "vuex";
import commonApi from "@/api/common.js";
//  // import config from '@/utils/config';;

export default {
  components: {
    iochart,
  },
  data() {
    return {
      tableheight: 240,

      listlength: null,
      radardata: null,
      piedata: null,
      linedata: null,
      linedata2: null,
      hoverindex: null,
      tiplist: [
        {
          name: "Enabled",
          url: require("../../assets/Switch.png"),
        },
        {
          name: "Disabled",
          url: require("../../assets/Switch (2).png"),
        },
        {
          name: "Indicator Current Value",
          url: require("../../assets/rectangle 6 (5).png"),
        },
        {
          name: "Indicator Target Value",
          url: require("../../assets/rectangle 6 (1).png"),
        },
        {
          name: "Indicator Abnormal",
          url: require("../../assets/rectangle 6 (2).png"),
          type: 1,
        },
        {
          type: 1,
          name: "Data Fluctuation Trend",
          url: require("../../assets/path 1 (2).png"),
        },
        {
          type: 1,
          name: "Data Distribution",
          url: require("../../assets/group 2 (5).png"),
        },
        {
          name: "On",
          url: require("../../assets/rectangle 6 (3).png"),
        },
        {
          name: "Off",
          url: require("../../assets/rectangle 6 (4).png"),
        },
        {
          type: 1,
          name: "Malfunction",
          url: require("../../assets/warning.png"),
        },
      ],
      o: [],
      show: false,
      queryInfo: {
        pagenum: 1,
        pagesize: 10,
      },
      height: "400px",
      alertAllData: [],
      timer: null,
      timeout: null,
    };
  },
  sockets: {

    data(res) {
      this.allCurrent = JSON.parse(res);
      // console.log(this.allCurrent);
      this.refreshData = this.allCurrent.refresh;
      this.addonData = this.allCurrent.addon;
      console.log(this.piedata);
      console.log(this.refreshData);
      for (let k = 0; k < this.piedata.length; k++) {
        for (let j = 0; j < this.piedata[k].length; j++) {
          this.piedata[k][j].current = this.refreshData[this.piedata[k][j].index][j];
        }
      }
      console.log(this.piedata);
    },
  },
  computed: {
    // transform() {
    //   let num = this.listlength;
    //   let angle = 360 / num;
    //   let arr = ['translate(104%, -55%)', 'translate(302%,125%)', 'translate(364%,597%)',
    //     'translate(342%,1126%)', 'translate(246%,1471%)', 'translate(40%,1471%)',
    //     'translate(-56%,1126%)', 'translate(-77%,597%)', 'translate(-15%,125%)'];
    //   return arr;
    // },
    transform() {
      let num = this.listlength;
      let angle = 360 / num;
      let arr = [];
      for (let index = 0; index < num; index++) {
        arr.push(index * angle);
      }
      //   let arr = ['translate(104%, -55%)', 'translate(302%,125%)', 'translate(364%,597%)',
      //     'translate(342%,1126%)', 'translate(246%,1471%)', 'translate(40%,1471%)',
      //     'translate(-56%,1126%)', 'translate(-77%,597%)', 'translate(-15%,125%)'];
      arr = arr.map((d) => this.getAxis(d));
      return arr;
    },
    ...mapState(["theme"]),
  },
  watch: {
    theme(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (newVal == "westeros") {
        this.charttheme = "light";
      } else {
        this.charttheme = "dark";
      }
      this.getallequipmentData();
      this.getIntelligentAerationData();
      // this.getalllineData()
      this.getChartData();
      this.getAlertAllData();
    },
  },
  beforeDestroy() {
    // this.myChart.clear()
    clearInterval(this.timer);
  },
  created() {
    let theme = localStorage.getItem("theme")
      ? JSON.parse(localStorage.getItem("theme"))
      : "light";
    console.log(theme);
    this.charttheme = theme;
    // this.tableheight = this.$refs.water_table.offsetHeight
    this.getallequipmentData();
    this.getIntelligentAerationData();
    // this.getalllineData()
    this.getChartData();
    this.getAlertAllData();
  },
  mounted() {
    console.log('mounted__________________________');
    // this.fontSize = this.$refs.tiplittlebox
    // console.log(this.fontSize);
    // this.getmodeltype()
    // this.$nextTick(() => {
    //   this.fontSize = this.$refs.indexcontainer
    //   console.log(this.$refs.myindexcontainer);
    // });
    // tableBodyDom.addEventListener('scroll', () => {
    //     console.log(11111);
    // })
  },
  methods: {
    gotoaidetail() {

    },
    Changeinwater() {

    },
    Changeoutwater() {

    },
    watchinwater() {

    },
    watchoutwater() {

    },
    scrollinwater() {

    },
    scrolloutwater() {

    },
    gotowarning() {

    },
    getAutoHeight() {
      let el = document.querySelector("#tableData"),
        elParent = el.parentNode,
        pt = this.getStyle(elParent, "paddingTop"),
        pb = this.getStyle(elParent, "paddingBottom");
      this.$nextTick(() => {
        this.height = el.clientHeight - (pt + pb) + "px";
        console.log(elParent.clientHeight, pt, pb, this.height);
      });
    },
    handleScroll(index) {
      console.log(index);
    },
    debounce(func, delay) {
      let context = this;
      let args = arguments;
      return (function () {
        if (context.timeout) {
          clearTimeout(context.timeout);
        }
        context.timeout = setTimeout(() => {
          func.apply(context, args);
        }, delay);
      })();
    },

    //获取警报列表
    async getAlertAllData() {
      const { data: res } = await this.$http.get("/alarm/record/list", {
        params: this.queryInfo,
      });
      if (res.code !== 200) {
        return this.$message.error("error");
      }
      this.alertAllData = res.data.data;
    },
    selectChanged(index, item) {
      console.log(index, item);
      console.log(this.chartData[index]);
      if (index == 0) {
        this.Changeinwater();
      } else {
        this.Changeoutwater();
      }
      this.chartData[index].data.map((v) => {
        if (v.title == item) {
          this.o[index].selectchart = v;
        }
      });
    },
    async getmodeltype() {
      const { data: res } = await this.$http.get("/modules/extra", {
        params: { type: "curr" },
      });
      console.log(res.data.result);
      let arr = [];
      this.o = [];
      for (let i = 0; i < res.data.result.length; i++) {
        this.o.push({
          name: res.data.result[i].type,
          value: res.data.result[i].data,
          chartdata: this.chartData[i],
          selectvalue: this.chartData[i].data[0].title,
          selectchart: this.chartData[i].data[0],
        });
      }
      this.show = true;
      console.log(this.o);
      this.$nextTick(() => {
        this.tableheight = this.$refs.watertable[0].offsetHeight
        // console.log(this.$refs.watertable);
      });
    },
    async getChartData() {
      const { data: res } = await this.$http.get("/modules/extra", {
        params: { type: "chart" },
      });
      this.chartData = res.data.result;
      // for (let i = 0; i < this.chartData.length; i++) {
      //     this.o[i]['chartdata'] = this.chartData[i]
      // }
      this.getmodeltype();
      this.timer = window.setInterval(() => {
        setTimeout(this.getmodeltype(), 0);
      }, 300000);
    },
    changeChart(item) {
      console.log(item);
      this.bigchartdata = item;
      console.log(item);
    },
    handleClick(tab, event) {
      this.changeChart(this.chartData[tab.index].data[0]);
    },
    async gotodetail(item) {
      console.log(item);

      // if (item.result.index !== 7) {
      console.log(item);
      const { data: res } = await this.$http.get("/modules/facilities", {
        params: { index: item.index },
      });
      const { data: res1 } = await this.$http.get("/modules/chart", {
        params: { index: item.index },
      });
      // const length = res.data.result.facilities.length;
      // const openCharts = res1.data.result.length;
      // console.log(length);
      // const openCharts = res1.data.result.length;
      // console.log(openCharts);
      this.$router.push({
        path: "/ai/detail",
        query: {
          index: item.index,
          module: item.module,
        },
      });
      // }
      // console.log(index);
    },
    getAxis(angle) {
      let height = this.$refs.demo.offsetHeight / 2
      let width = this.$refs.demo.offsetWidth
      console.log(height * Math.sin((angle * Math.PI) / 180), angle, height, width);

      if (angle <= 180) {
        return `translate(${height * Math.sin((angle * Math.PI) / 180) + height}px, ${height - height * Math.cos((angle * Math.PI) / 180) - height / 15
          }px)`;
      } else {
        return `translate(${(height * Math.sin((angle * Math.PI) / 180)) + height / 2.2}px, ${height - height * Math.cos((angle * Math.PI) / 180) - height / 15
          }px)`;
      }
    },
    logsome(i) {
      let myzindex = "z-index";
      this.hoverindex = i;
    },
    // 获取所有设备数据
    async getallequipmentData() {
      const { data: res } = await this.$http.get("/modules/facilities/all");
      let allstatus = res.data.result;
      let radardata = [];
      let ridus = 360 / allstatus.length;
      for (let a = 0; a < allstatus.length; a++) {
        let inforidus = ridus / allstatus[a].facilities.length;
        for (let b = 0; b < allstatus[a].facilities.length; b++) {
          // console.log(ridus * a, inforidus * b);
          if (allstatus[a].facilities[b].state == 0) {
            radardata.push({
              // ridus * a + inforidus * b
              value: [
                Math.random() * (105 - 10) + 30,
                Math.random() * (ridus * (a + 1) - ridus * a) + ridus * a,
                allstatus[a].facilities[b].id,
              ],
              itemStyle: {
                color: "#fff",
                borderColor: "rgba(39, 111, 183, 1)",
                borderWidth: 1,
              },
              emphasis: { itemStyle: { borderColor: "#313235", borderWidth: 1 } },
            });
          } else {
            radardata.push({
              value: [
                Math.random() * (105 - 10) + 30,
                Math.random() * (ridus * (a + 1) - ridus * a) + ridus * a,
                allstatus[a].facilities[b].id,
              ],
              itemStyle: { color: "rgba(39, 111, 183, 1)" },
              emphasis: { itemStyle: { borderColor: "#313235", borderWidth: 1 } },
            });
          }
        }
      }
      console.log(radardata);
      this.radardata = radardata;
      this.initradarChart();
      if (res.meta.status !== 200) {
        return this.$message.error("error");
      }
    },
    // 获取所有重要数据
    async getalllineData() {
      const { data: res } = await this.$http.get("/modules/chart/all");
      let result = res.data.result;
      let arr1 = [];
      let arr2 = [];
      // [x,y]
      for (let a = 0; a < result.length; a++) {
        if (result[a].chart_table.length > 0) {
          arr1.push(result[a].chart_table[0]);
          arr2.push(result[a].chart_table[1]);
        } else {
          arr1.push(result[0].chart_table[0]);
          arr2.push(result[0].chart_table[1]);
        }
      }
      this.linedata = arr1;
      console.log(this.linedata);

      this.linedata2 = arr2;
      this.$nextTick(() => {
        this.initlineChart();
        this.initline2Chart();
      });

      if (res.meta.status !== 200) {
        return this.$message.error("error");
      }
    },
    //获取页面所有模块数据
    async getIntelligentAerationData() {
      const { data: res } = await this.$http.get("/modules/initall?mode=filter");
      if (res.meta.status !== 200) {
        return this.$message.error("error");
      }
      this.inAerationData = res.data.result;
      let allmodeldata = res.data.result;
      let piedata = [];

      // console.log(this.inAerationData);

      for (let a = 0; a < this.inAerationData.length; a++) {
        let infodata = [];
        for (let b = 0; b < this.inAerationData[a].result.table.length; b++) {
          if (this.inAerationData[a].result.table[b].floating_target) {
            if (this.inAerationData[a].result.table[b].target !== "NA") {
              infodata.push({
                index: this.inAerationData[a].result.index,
                id: this.inAerationData[a].result.table[b].id,
                visible: this.inAerationData[a].result.table[b].visible,
                tag: this.inAerationData[a].result.table[b].tag,
                current: this.inAerationData[a].result.table[b].current,
                target: (
                  (this.inAerationData[a].result.table[b].target[0] +
                    this.inAerationData[a].result.table[b].target[1]) /
                  2
                ).toFixed(2),
                unit: this.inAerationData[a].result.table[b].unit,
                show: this.inAerationData[a].result.table[b].show,
                floating_target: (
                  (this.inAerationData[a].result.table[b].floating_target[0] +
                    this.inAerationData[a].result.table[b].floating_target[1]) /
                  2
                ).toFixed(2),
              });
            } else {
              infodata.push({
                index: this.inAerationData[a].result.index,
                id: this.inAerationData[a].result.table[b].id,
                visible: this.inAerationData[a].result.table[b].visible,
                tag: this.inAerationData[a].result.table[b].tag,
                current: this.inAerationData[a].result.table[b].current,
                target: this.inAerationData[a].result.table[b].target,
                show: this.inAerationData[a].result.table[b].show,
                unit: this.inAerationData[a].result.table[b].unit,
                // floating_target: ((this.inAerationData[a].result.table[b].floating_target[0] + this.inAerationData[a].result.table[b].floating_target[1]) / 2).toFixed(2),
              });
            }
          } else {
            if (this.inAerationData[a].result.table[b].target !== "NA") {
              infodata.push({
                index: this.inAerationData[a].result.index,
                id: this.inAerationData[a].result.table[b].id,
                visible: this.inAerationData[a].result.table[b].visible,
                tag: this.inAerationData[a].result.table[b].tag,
                current: this.inAerationData[a].result.table[b].current,
                target: (
                  (this.inAerationData[a].result.table[b].target[0] +
                    this.inAerationData[a].result.table[b].target[1]) /
                  2
                ).toFixed(2),
                unit: this.inAerationData[a].result.table[b].unit,
                show: this.inAerationData[a].result.table[b].show,
              });
            } else {
              infodata.push({
                index: this.inAerationData[a].result.index,
                id: this.inAerationData[a].result.table[b].id,
                visible: this.inAerationData[a].result.table[b].visible,
                tag: this.inAerationData[a].result.table[b].tag,
                current: this.inAerationData[a].result.table[b].current,
                target: this.inAerationData[a].result.table[b].target,
                show: this.inAerationData[a].result.table[b].show,
                unit: this.inAerationData[a].result.table[b].unit,
              });
            }
          }
        }
        piedata.push(infodata);
      }
      console.log(piedata);
      this.piedata = piedata;
      // this.listlength = piedata.length
      this.listlength = piedata.length;
      this.tables = this.inAerationData;
      // this.initlineChart()
      // this.initline2Chart()
      this.getalllineData();

      this.initpieChart();
      this.initcategoryChart();
      this.initradarChart();
    },
    //外围指标
    initpieChart() {
      // this.fontSize
      // this.fontSize = this.$refs.demo[0].currentStyle.fontSize
      // this.fontSize = this.$refs.tiplittlebox
      // console.log(this.fontSize);
      let height = this.$refs.demo.offsetHeight / 2
      console.log(height);

      this.$nextTick(() => {
        // this.fontSize
        var element = document.getElementById('myElement');
        var style = window.getComputedStyle(element, null);
        this.fontSize = style.getPropertyValue('font-size');
        console.log(this.fontSize);
      });
      // console.log(this.initOption);
      for (let a = 0; a < this.piedata.length; a++) {
        let radiusarr = [];
        let currentarr = [];
        let targetarr = [];
        for (let b = 0; b < this.piedata[a].length; b++) {
          // console.log(this.piedata[a][b].show);
          if (this.piedata[a][b].show) {
            radiusarr.push(this.piedata[a][b].visible);
            if (this.piedata[a][b].floating_target) {
              console.log(this.piedata[a][b].floating_target);

              // currentarr.push(this.piedata[a][b].current / this.piedata[a][b].floating_target * 1)
              if (
                (this.piedata[a][b].current / this.piedata[a][b].floating_target) * 1 <
                0.6
              ) {
                currentarr.push(0.6);
              } else if (
                (this.piedata[a][b].current / this.piedata[a][b].floating_target) * 1 >
                1.5
              ) {
                currentarr.push(1.5);
              } else {
                currentarr.push(
                  (this.piedata[a][b].current / this.piedata[a][b].floating_target) * 1
                );
              }
              targetarr.push(1);
            } else {
              if (this.piedata[a][b].target !== "NA") {
                if ((this.piedata[a][b].current / this.piedata[a][b].target) * 1 < 0.6) {
                  currentarr.push(0.6);
                } else if (
                  (this.piedata[a][b].current / this.piedata[a][b].target) * 1 >
                  1.5
                ) {
                  currentarr.push(1.5);
                } else {
                  currentarr.push(
                    (this.piedata[a][b].current / this.piedata[a][b].target) * 1
                  );
                }
                targetarr.push(1);
              } else {
                currentarr.push(1);
                targetarr.push(this.piedata[a][b].target);
              }
            }
          }
        }
        // console.log(targetarr);
        // console.log(currentarr);
        // console.log(this.piedata[a]);

        let that = this;
        let colorarr = null;
        if (this.charttheme == "light") {
          colorarr = ["#4F84B9", "#038880", "#61a0a8"];
        } else {
          colorarr = ["#008080FF", "#40E0D0FF", "#61a0a8"];
        }
        let myinitOption = {
          backgroundColor: "",
          color: colorarr,
          polar: {
            radius: [height / 2, "100%"],
          },
          angleAxis: {
            max: function (value) {
              return value.max + 0.5;
            },
            startAngle: 90 - (360 / this.listlength) * a,
            endAngle: 90 - (360 / this.listlength) * (a + 1),
            axisLine: {
              // show: false
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
          radiusAxis: {
            type: "category",
            data: radiusarr,
          },
          tooltip: {

            renderMode: "html",
            appendTo: this.$refs.mypie,
            trigger: "item",
            position: "inside",
            axisPointer: {
              type: "shadow",
            },
            formatter: function (params, ticket, callback) {
              // console.log(params)
              // console.log(that.piedata);
              for (let a = 0; a < that.piedata.length; a++) {
                for (let b = 0; b < that.piedata[a].length; b++) {
                  if (params.name == that.piedata[a][b].visible) {
                    // console.log(that.piedata[a]);
                    if (that.piedata[a][b].floating_target) {
                      return (
                        params.name +
                        "<br/> Current Value：" +
                        that.piedata[a][b].current +
                        "Dynamic Target Value：" +
                        that.piedata[a][b].floating_target
                      );
                    } else {
                      return (
                        params.name +
                        "<br/> Current Value：" +
                        that.piedata[a][b].current +
                        "Target Value：" +
                        that.piedata[a][b].target
                      );
                    }
                  }
                }
              }
            },
          },
          series: [
            {
              type: "bar",
              data: currentarr,
              coordinateSystem: "polar",
              // color: red,
              label: {
                color: "#FFFFFF",
                show: true,
                position: "middle",
                formatter: "{b}",
                textStyle: {
                  fontSize: this.fontSize, // 标签字体大小
                },
              },
            },
            {
              type: "bar",
              data: targetarr,
              barWidth: 5,
              coordinateSystem: "polar",
              barCategoryGap: "-15%",
              barGap: "0%",
              label: {
                show: false,
                position: "middle",
                formatter: "{b}: {c}",
              },
            },
          ],
        };
        // console.log(myinitOption.angleAxis.startAngle, myinitOption.angleAxis.endAngle);
        let newPromise = new Promise((resolve) => {
          resolve();
        });
        newPromise.then(() => {
          // console.log(this.theme);
          let that = this;
          this.myChart = this.$echarts.init(
            document.getElementById("containerpie" + (a + 1)),
            this.theme
          );
          this.myChart.setOption(myinitOption);
          this.myChart.on("mouseover", function () {
            // console.log('ffffffffffffffffffffffffff');
            document.getElementById("myline").style.zIndex = 0;
            document.getElementById("myline2").style.zIndex = 0;
            document.getElementById("pie").style.zIndex = 9;

          });
          this.myChart.on("globalout", function () {
            // console.log('out', a);
            document.getElementById("myline").style.zIndex = 1;
            document.getElementById("myline2").style.zIndex = 1;
            document.getElementById("pie").style.zIndex = 0;

          });
          // console.log(this.myChart);
          this.myChart.getZr().on("click", function (param) {
            if (param.offsetY > 60) {
              that.$emit("closedrawer");
              console.log(23232434343);
              console.log(param);
            }
          });
        });
      }
    },

    num(num) {
      // console.log(num);
      var count = 0;
      while (num >= 10) {
        num = num / 10;
        // console.log(num);
        count++;
      }
      // console.log(count);
      return count;
    },
    initcategoryChart() {
      for (let a = 0; a < this.listlength; a++) {
        // console.log(this.inAerationData[a].result.table);
        let data = [];
        let that = this;
        let radiusarr = [];
        for (let b = 0; b < this.inAerationData[a].result.table.length; b++) {
          radiusarr.push(this.inAerationData[a].result.table[b].visible);
          if (this.inAerationData[a].result.table[b].current < 10) {
            data.push(this.inAerationData[a].result.table[b].current);
          } else {
            data.push(
              this.inAerationData[a].result.table[b].current /
              10 ** this.num(this.inAerationData[a].result.table[b].current)
            );
          }
        }
        // color: ['#00364D'],
        let colorarr = null;
        if (this.charttheme == "light") {
          colorarr = ["#498195"];
        } else {
          colorarr = ["#40E0D0"];
        }
        let myinitOption = {
          color: colorarr,
          polar: {
            radius: [100, "100%"],
          },
          radiusAxis: {
            // show: false
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
          angleAxis: {
            data: radiusarr,
            startAngle: 90 - (360 / this.listlength) * a,
            endAngle: 90 - (360 / this.listlength) * (a + 1),
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
          tooltip: {

            appendTo: this.$refs.mycategory,
            appendToBody: false,
            trigger: "item",
            axisPointer: {

              type: "shadow",
            },
            // appendToBody: true,
            formatter: function (params, ticket, callback) {
              // console.log(params)
              // console.log(that.piedata);
              for (let a = 0; a < that.inAerationData.length; a++) {
                // console.log(that.inAerationData[a]);
                for (let b = 0; b < that.inAerationData[a].result.table.length; b++) {
                  // console.log(that.inAerationData[a].result.table[b]);
                  if (params.name == that.inAerationData[a].result.table[b].visible) {
                    return (
                      params.name +
                      "<br/> Current Value：" +
                      that.inAerationData[a].result.table[b].current
                    );
                  }
                }
              }
            },
          },
          series: {
            type: "bar",
            data: data,
            coordinateSystem: "polar",
            barCategoryGap: "0%",
            label: {
              show: false,
              position: "middle",
              formatter: "{b}: {c}",
            },
          },
        };
        let newPromise = new Promise((resolve) => {
          resolve();
        });
        newPromise.then(() => {
          // console.log(this.theme);
          let that = this;
          this.myChart = this.$echarts.init(
            document.getElementById("category" + (a + 1))
          );
          this.myChart.setOption(myinitOption);
          // console.log(this.myChart);
          this.myChart.on("globalout", function () {
            console.log("out", a);

          });
          this.myChart.getZr().on("click", function (param) {
            if (param.offsetY > 60) {
              that.$emit("closedrawer");
              console.log(23232434343);
              console.log(param);
            }
          });
        });
      }
    },
    changedata(data, x) {
      let arr = [];
      for (let a = 0; a < data.yAxis.length; a++) {
        arr.push([data.yAxis[a], a]);
      }
      return arr;
    },
    changemarkdata(data) {
      let arr = [];
      for (let a = 0; a < data.length; a++) {
        if (a == data.length - 1) {
        } else {
          arr.push([
            {
              coord: data[a],
              lineStyle: {
                width: 0.1,
                type: "solid",
                color: "#3E3E3E",
              },
            },
            {
              coord: data[a + 1],
              lineStyle: {
                width: 0.1,
                type: "solid",
                color: "#3E3E3E",
              },
            },
          ]);
        }
      }
    },
    searchMax(arr) {
      var max = 0;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] > max) {
          max = arr[i];
        }
      }
      return max;
    },
    //折线图
    initlineChart() {
      for (let a = 0; a < this.linedata.length; a++) {
        if (this.linedata[a]) {
          let myseries = [];
          let max = null;
          let colorarr = null;
          if (this.charttheme == "light") {
            colorarr = "#370C6";
          } else {
            colorarr = "#ACACAC";
          }
          for (let b = 0; b < this.linedata[a].legend.length; b++) {
            max = this.searchMax(this.linedata[a].legend[b].yAxis);
            let data = this.changedata(
              this.linedata[a].legend[b],
              this.linedata[a].xAxis
            );
            let markdata = this.changemarkdata(data);
            // console.log(data);
            myseries.push({
              name: this.linedata[a].legend[b].name,
              type: "line",
              coordinateSystem: "polar",
              // symbolSize: 1,
              symbol: "none",
              lineStyle: {
                color: colorarr,
                width: 1,
              },
              data: data,
              // markLine: markdata
            });
            // if(max>)
          }
          // console.log(myseries);
          const days = this.linedata[a].xAxis;
          let myinitOption = {
            backgroundColor: "",

            polar: {
              radius: [210, "100%"],
            },
            angleAxis: {
              startAngle: 90 - (360 / this.listlength) * a,
              endAngle: 90 - (360 / this.listlength) * (a + 1),
              splitLine: {
                show: false,
              },
              axisLine: {
                show: true,

                lineStyle: {
                  color: "rgba(113, 68, 31, 1)",
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
            },
            radiusAxis: {
              // show: false,
              // data: days,
              splitLine: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
            },

            series: myseries,
          };
          console.log(myinitOption);
          let newPromise = new Promise((resolve) => {
            resolve();
          });
          newPromise.then(() => {
            let that = this;
            this.myChart = this.$echarts.init(
              document.getElementById("line" + (a + 1)),
              this.theme
            );
            this.myChart.setOption(myinitOption);
            // console.log(this.myChart);
            this.myChart.getZr().on("click", function (param) {
              if (param.offsetY > 60) {
                that.$emit("closedrawer");
              }
            });
          });
        }
      }
    },
    initline2Chart() {
      for (let a = 0; a < this.linedata2.length; a++) {
        // console.log(this.linedata2);
        if (this.linedata2[a]) {
          // console.log(this.linedata2[a].title);
          // console.log(this.linedata2[a]);
          let colorarr = null;
          if (this.charttheme == "light") {
            colorarr = "#370C6";
          } else {
            colorarr = "#ACACAC";
          }
          let myseries = [];
          let max = null;
          for (let b = 0; b < this.linedata2[a].legend.length; b++) {
            max = this.searchMax(this.linedata2[a].legend[b].yAxis);
            let data = this.changedata(
              this.linedata2[a].legend[b],
              this.linedata2[a].xAxis
            );
            let markdata = this.changemarkdata(data);
            // console.log(data);
            myseries.push({
              name: "Punch Card",
              type: "line",
              coordinateSystem: "polar",
              // symbolSize: 1,
              symbol: "none",
              lineStyle: {
                color: colorarr,
                width: 1,
              },
              data: data,
            });
            // if(max>)
          }

          const days = this.linedata2[a].xAxis;
          let myinitOption = {
            backgroundColor: "",
            polar: {
              radius: [170, "100%"],
            },
            angleAxis: {
              startAngle: 90 - (360 / this.listlength) * a,
              endAngle: 90 - (360 / this.listlength) * (a + 1),
              // data: hours,
              // boundaryGap: false,
              splitLine: {
                show: false,
              },
              axisLine: {
                show: true,

                lineStyle: {
                  color: "rgba(113, 68, 31, 1)",
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
            },
            radiusAxis: {
              // show: false,
              // data: days,
              splitLine: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
            },
            series: myseries,
          };
          let newPromise = new Promise((resolve) => {
            resolve();
          });
          newPromise.then(() => {
            // console.log(this.theme);
            let that = this;
            this.myChart = this.$echarts.init(
              document.getElementById("line2" + (a + 1)),
              this.theme
            );
            this.myChart.setOption(myinitOption);
            // console.log(this.myChart);
            this.myChart.getZr().on("click", function (param) {
              if (param.offsetY > 60) {
                that.$emit("closedrawer");
                console.log(23232434343);
                console.log(param);
              }
            });
          });
        }
      }
    },
    initradarChart() {
      // console.log(this.initOption);
      let myinitOption = {
        title: { show: false },
        polar: {},
        angleAxis: {
          zlevel: 1,
          z: 1,
          min: 0,
          max: 360,
          interval: 360 / this.listlength,
          // axisLabel: { color: '#AAAAAA' },
          axisTick: { show: false },
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: { lineStyle: { color: "#00364D", type: "dashed" } },
        },

        radiusAxis: {
          zlevel: 1,
          z: 1,
          max: 150,
          splitNumber: 1,
          axisLabel: { show: false },
          axisLine: { show: false },
          axisTick: { show: false },
          minorTick: { show: false },
          // splitLine: { lineStyle: { color: '#088A29' } },
        },
        tooltip: {
          appendToBody: true,
          show: true,
          trigger: "item",
          formatter: function (params) {
            let html = "<div><div>name：" + params.value[2];
            return html;
          },
        },
        series: [
          {
            coordinateSystem: "polar",
            zlevel: 2,
            z: 2,
            symbolSize: 7,
            name: "scatter",
            type: "scatter",
            data: this.radardata,
          },

          // {
          //     type: 'pie',
          //     radius: '100%',
          //     zlevel: 1,
          //     z: 1,
          //     silent: true,
          //     data: [0],
          //     itemStyle: { color: 'rgba(128, 128, 128, 0.0)' },
          //     labelLine: { show: false },
          // },
        ],
      };
      // console.log(myinitOption.angleAxis.startAngle, myinitOption.angleAxis.endAngle);
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      newPromise.then(() => {
        // console.log(this.theme);
        let that = this;
        this.myChart = this.$echarts.init(document.getElementById("radar"), this.theme);
        this.myChart.setOption(myinitOption);
        // console.log(this.myChart);
        this.myChart.getZr().on("click", function (param) {
          if (param.offsetY > 60) {
            that.$emit("closedrawer");
            console.log(23232434343);
            console.log(param);
          }
        });
      });
    },
    leave(i) {
      // console.log(123333333333333333);
      document.getElementById("myradar").style.zIndex = 0;
      // document.getElementById("myline").style.zIndex = 9;
      // document.getElementById("myline2").style.zIndex = 9;
      // document.getElementById("pie").style.zIndex = 0;
      document.getElementById("containerpie" + i).style.zIndex = 8;
      this.hoverindex = null;
    },
    handle(row) {
      // console.log(this.openIndex);
      this.gotowarning();
      this.$router.push({
        path: "/alertDetail",
        query: { id: row.id, index: this.openIndex, from: "aieyes" },
      });
    },
    clickOutSide(index) {
      setTimeout(() => {
        console.log('111111111111111111111111');
        console.log(new Date());
        this.$refs.mySelect[index].blur()
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.indexcontainer {
  font-size: 16px;
  margin-top: 40px;
  height: 93vh;
  position: relative;
}

.allwarning {
  position: absolute;
  top: 0;
  right: 69px;
  width: 550px;

  ::-webkit-scrollbar {
    width: 0px !important;
  }
}

.inAndOutOfWater {
  position: absolute;
  top: 0;
  left: 60px;
  width: 358px;
  // height: 600px;
  // background-color: rgba(255, 255, 255, 1);

  // background-color: red
  .water_info {
    color: #CCCCCCFF;
    height: calc(41vh);
    padding: 18px 12px;
    background: rgba(26, 26, 34, 1);
    border-radius: 20px;
    margin-bottom: 28px;

    .watertitle {
      font-size: 16px;
    }
  }

  .water_table {
    border-bottom: 1px solid rgb(59, 59, 59);
    height: calc(19vh);
  }

  .water_chartbox {
    margin-top: 10px;
    text-align: center;

    .water_chart {
      margin-top: 20px;
      width: 100%;
      height: 190px;
    }
  }
}

.indexcontainer_fack {
  // z-index: -1;
  // position: absolute;
  // top: 0;
  // left: 650px;
  // transform: translate(-50%, 50%);
  // right: 0;
  // width: 1100px;
  height: 93vh;
  display: flex;
  align-items: center;
  justify-content: center;

  // position: relative;
  // margin-top: 20px;
  .container_fack {
    height: 93vh;
    width: 1100px;
    background-color: #fafafc;
    background: url("../../assets/未标题-3-01.png.png") no-repeat center center; //背景图
    background-size: 1066px 1066px;
    // background-position: center center;
    animation: wm 60s infinite linear;
  }
}

@keyframes wm {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.hoverstyle {
  z-index: 999;
  // transform: scale(2);
}

.mycategory {
  z-index: 10;
  position: absolute;
  margin: auto;
  padding: 0;
  width: 342px;
  height: 342px;
  // background-color: red;
  border-radius: 50%;
  list-style: none;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.myline {
  z-index: 9;
  position: absolute;
  margin: auto;
  padding: 0;
  width: 504px;
  height: 504px;
  // background-color: red;
  border-radius: 50%;
  list-style: none;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.pie {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  padding: 0;
  width: 1014px;
  height: 1014px;
  border-radius: 50%;
  list-style: none;
  background-color: rgba(38, 105, 170, 0);
  // overflow: hidden;
  // overflow: ;
  // background-color: red;
}

.slice {
  overflow: hidden;
  position: absolute;
  // border-radius: 100%;
  top: 0;
  right: 0;
  width: 50%;
  height: 50%;
  transform-origin: 0% 100%;
}

.d1 {
  width: 507px;
  height: 507px;
  position: absolute;
  right: 0;
  top: 0;
  transform-origin: 0% 100%;
  // overflow: hidden
  // transform: skewX(135deg) rotate(0deg);
}

// .slice::after {
//     content: "";
//     display: inline-block;
//     overflow: hidden;
//     position: absolute;
//     border-radius: 100%;
//     z-index: 969999;
//     top: 0%;
//     right: 0%;
//     width: 1014px;
//     height: 1014px;
//     border-radius: 50%;
// }

.containerpie {
  width: 1014px;
  height: 1014px;
  position: absolute;
  left: -100%;
  border-radius: 50%;
}

.category {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 50%;
  transform-origin: 0% 100%;
  // background: rgb(175, 25, 182);
}

.category_container {
  width: 342px;
  height: 342px;
  position: absolute;
  left: -100%;
  border-radius: 50%;
}

.line {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 50%;
  transform-origin: 0% 100%;
}

.line_container {
  width: 504px;
  height: 504px;
  position: absolute;
  left: -100%;
  border-radius: 50%;
}

.myline2 {
  z-index: 9;
  position: absolute;
  margin: auto;
  padding: 0;
  width: 420px;
  height: 420px;
  // background-color: red;
  border-radius: 50%;
  list-style: none;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.line2 {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 50%;
  transform-origin: 0% 100%;
}

.line_container2 {
  width: 420px;
  height: 420px;
  position: absolute;
  left: -100%;
  border-radius: 50%;
}

.myradar {
  // background-color: #fff;
  z-index: 11;
  position: absolute;
  margin: auto;
  padding: 0;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  list-style: none;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  // overflow: hidden;
  // background-color: red
}

.radar_container {
  width: 200px;
  height: 200px;
  position: absolute;
  border-radius: 50%;
}

.pie_bord {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  padding: 0;
  width: 1034px;
  height: 1034px;
  border-radius: 50%;
  list-style: none;

  // overflow: hidden;
  .imgbox {
    transform: translateX(320px) rotate(30deg) translateY(220px);
  }

  .bordbox {
    width: 1px;
    height: 30px;
    float: left;
    border-left: 1px solid red;
    // display: block;
  }

  img {
    left: 1702.52px;
    top: 395.92px;
    width: 26.42px;
    height: 14.3px;
    opacity: 1;
    transform: rotate(180deg);
  }
}

.bord {
  // overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 50%;
  transform-origin: 0% 100%;
  // background-color: #1782D4;
}

.text_bord {
  // position: relative;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  padding: 0;
  width: 1100px;
  height: 1100px;
  border-radius: 50%;
  list-style: none;

  .imgbox {
    transform: translateX(320px) rotate(30deg) translateY(220px);
  }

  .bordbox {
    width: 1px;
    height: 40px;
    float: left;
    border-left: 1px dashed #40E0D0;
    // background-color: #1782D4;
    // display: block;
  }

  img {
    left: 1702.52px;
    top: 395.92px;
    width: 26.42px;
    height: 14.3px;
    opacity: 1;
    transform: rotate(180deg);
  }
}

.text_box {
  width: 300px;
  // position: absolute;
  // left: -100%;
  text-align: center;
  // top: 5%;
  // transform: translate(-50%, -50%);

  .module_title {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #40E0D0;
    padding-bottom: 10px;
    font-size: 15px;
    width: 300px;
    height: 26px;

    img {
      margin-left: 10px;
      width: 27.18px;
      height: 26px;
    }
  }

  .module_type {
    margin-top: 10px;
  }

  // background-color: red;
}

.demo {
  cursor: pointer;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 1100px;
  height: 1100px;
  box-sizing: border-box;
  font-size: 16px;
  // background-color: #fafafc;

  ul,
  li {
    margin: 0;
    list-style-type: none;
    padding: 0;
  }

  ul {
    width: 1100px;
    height: 1100px;
    border-radius: 50%;
    position: relative;
    // background-color: red;
  }

  li {
    position: absolute;
    // background-color: #40E0D0;
  }
}

.tip_box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: absolute;
  bottom: 73.9px;
  right: 71.5px;
  width: 400.1px;
  height: 295.1px;
  opacity: 1;
  border-radius: 23.4px;
  color: rgba(204, 204, 204, 1);
  background: rgba(37, 37, 38, 0.6);
  box-shadow: 0px 2.6px 9.1px rgba(0, 0, 0, 0.05);

  .tip_littlebox {
    margin-top: 30px;
    margin-left: 36px;
    margin-right: 36px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 16px;
  }

  .tip {
    display: flex;
    align-items: center;
    // justify-content: center;
    width: 50%;

    img {
      width: 15px;
      margin-right: 6px;
    }
  }
}

#div {
  margin-top: 200px;
  margin-left: 200px;
  width: 100px;
  height: 100px;
  position: relative;
  // overflow: hidden;
}

#circle {
  position: absolute;
  right: 0;
  top: 0;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: blue;
  // overflow: hidden;

  clip-path: polygon(0% 100%, 50% 0%, 100% 00%); // 3个点确定一个3角形
  // transform: rotate(60deg);
}

#d1 {
  transform: skewX(135deg);
  transform-origin: 0 100%;
  position: absolute;
  right: 0;
  top: 0;
  background: red;
  width: 100px;
  height: 100px;
  // overflow: hidden;
}

.d2 {
  // overflow: hidden;
  transform: rotate(-45deg);
  transform-origin: 0 100%;
  position: absolute;
  right: 0;
  top: 0;
  background: rgb(233, 219, 26);
  width: 100px;
  height: 100px;
}

.d3 {
  transform: skewX(-135deg);
}

.jingaoContainer {
  width: 100%;
  height: 100%;
  cursor: pointer;

  .jingaospan {
    margin-left: 8px;
    margin-right: 10px;
    text-align: left;
    display: inline-block;
    font-size: 16px;
    font-weight: 600;
    color: #CCCCCCFF;
  }

  .jinggao_table {
    width: 100%;
    height: 400px;

    .first {
      color: rgba(235, 107, 106, 1);
    }
  }

  ::v-deep .el-table {
    width: 100%;
    margin-bottom: 50px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .el-table__header-wrapper table,
    .el-table__body-wrapper table {
      width: 100% !important;
    }

    .el-table__header-wrapper table,
    .el-table__body-wrapper table {
      width: 100% !important;
    }

    .el-table__body,
    .el-table__footer,
    .el-table__header {
      table-layout: auto !important;
    }

    .el-table .cell {
      padding-left: 0px !important;
    }

    .el-table__empty-block {
      width: 100% !important;
    }
  }

  ::v-deep .el-table {
    width: 100% !important;
    margin-top: 20px;
    border-radius: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  ::v-deep .el-table .cell {
    font-size: 14px;
  }

  .dotClass {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
  }

  /* 滚动条整体 */
  ::-webkit-scrollbar {
    height: 20px;
    width: 10px;
  }

  /* 两个滚动条交接处 -- x轴和y轴 */
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(214, 214, 214, 1);
  }

  /* 滚动条轨道 */
  ::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: rgba(240, 240, 240, 1);
  }
}
</style>
